import { motion } from "framer-motion";
import { ShieldCheck, Scale, FileText, Users, Briefcase, Building } from "lucide-react";

const areas = [

  {
    title: "Derecho Comercial",
    icon: <Building size={40} />,
    text: "Concursos preventivos, refinanciación de pasivos, conflictos societarios y de los negocios, contratos comerciales y reestructuración empresaria."
  },
  {
    title: "Derecho Laboral",
    icon: <Users size={40} />,
    text: "Asesoramiento a empleadores en relaciones laborales y negociación colectiva. Políticas internas, régimen disciplinario y defensa judicial."
  },
  {
    title: "Derecho Bancario",
    icon: <Briefcase size={40} />,
    text: "Procesos judiciales bancarios, cobro de créditos y ejecuciones promovidas por entidades financieras y empresas acreedoras."
  },
  {
    title: "Derecho Penal",
    icon: <Scale size={40} />,
    text: "Delitos económicos, fraude societario, administración fraudulenta, lavado de activos y responsabilidad penal corporativa."
  }
 
];

export default function PracticeAreas() {
  return (
    <section id="areas" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">

        <motion.h2
          className="text-3xl md:text-4xl text-center font-semibold text-primary mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Áreas de Práctica Jurídica
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {areas.map((area, i) => (
            <motion.div
              key={i}
              className="p-6 bg-gray-50 rounded-xl shadow-sm hover:shadow-md transition cursor-pointer border border-transparent hover:border-accent"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -6, transition: { type: "spring", stiffness: 200, damping: 14 } }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
            >
              <div className="flex justify-center text-primary mb-4">
                {area.icon}
              </div>
              <h3 className="text-xl font-semibold text-primary text-center">{area.title}</h3>
              <p className="text-gray-700 text-center mt-3">{area.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
